import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { durationInMonths } from '@progress/kendo-date-math'
import { MatDialog } from '@angular/material/dialog'
import { CancellationDialogComponent } from '../../dialogs/cancellation-dialog/cancellation-dialog.component'
import { ResendDialogComponent } from '../../dialogs/resend-dialog/resend-dialog.component'
import { SharedService } from '../../services/shared.service'
import { Contract } from '../../models/contract'

@Component({
	selector: 'app-user-info',
	templateUrl: './user-info.component.html',
	styleUrls: ['./user-info.component.css']
})
export class UserInfoComponent implements OnInit {
	contract: Contract
	percentDay: number
	
	constructor(
		private router: Router,
		private shared: SharedService,
		public dialog: MatDialog,
	) {	
		this.contract = this.shared.contract
		const startDate: number[] = this.contract.contractStartDate.split('-').map(Number)
		const endDate: number[] = this.contract.contractEndDate.split('-').map(Number)
		const start = new Date(startDate[0], startDate[1], startDate[2])
		const end = new Date(endDate[0], endDate[1], endDate[2])
		const current = new Date()
		this.percentDay = durationInMonths(start, current) / durationInMonths(start, end) * 100
		if (this.percentDay < 0) this.percentDay = 0
		else if (this.percentDay > 100) this.percentDay = 100
	}

	ngOnInit(): void {
		console.log(this.contract)
	}

	onUpdatePayment(): void {
		this.router.navigateByUrl('/payment')
	}

	onCancellation(): void {
		this.dialog.open(
			CancellationDialogComponent, 
			{ 
				data: {
					contract: this.contract
				}
			})
	}

	onResend(): void {
		this.dialog.open(
			ResendDialogComponent, 
			{ 
				data: {
					contract: this.contract
				}
			})
	}
}